import { ArrowRight } from "lucide-react";

export function ContactCTA({ onBook }: { onBook: () => void }) {
  return (
    <section className="contact-cta" id="contact">
      <div className="container">
        <div className="contact-band reveal">
          <div>
            <h2>Let's talk about the boring stuff.</h2>
            <p>
              A 30-minute intro call. No slides, no pitch. Bring the question
              that's been sitting on your desk.
            </p>
          </div>
          <div className="right">
            <button className="btn btn-petal" onClick={onBook}>
              Book a free intro
              <ArrowRight className="btn-arrow" size={16} />
            </button>
          </div>
        </div>
      </div>
    </section>
  );
}
